import { NgModule, ModuleWithProviders, InjectionToken, APP_INITIALIZER, Optional, SkipSelf } from '@angular/core';
import {
  MsalInterceptorConfiguration,
  MsalModule,
  MsalService,
  MSAL_GUARD_CONFIG,
  MSAL_INTERCEPTOR_CONFIG,
  MsalInterceptor,
  MSAL_INSTANCE,
  MsalGuardConfiguration,
  MsalGuard,
  MsalBroadcastService
} from '@azure/msal-angular';
import { Configuration, InteractionType, PublicClientApplication } from '@azure/msal-browser';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ConfigurationService } from 'src/app/shared/services/configuration/configuration.service';
import { throwIfAlreadyLoaded } from 'src/app/core/guard/moduleImport.guard';

const AUTH_CONFIG_TOKEN = new InjectionToken<string>('AUTH_CONFIG');

const isIE =
  window.navigator.userAgent.indexOf('MSIE ') > -1 ||
  window.navigator.userAgent.indexOf('Trident/') > -1;


export function initializerFactory(env: ConfigurationService): any {
  const promise = env.init().then((value) => {
  });
  return () => promise;
}

export function msalConfigFactory(configService: ConfigurationService) {
  return configService.getMsalConfigurations();
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ["user.read"]
    }
  };
}

export function MsalInstanceFactory(configService: ConfigurationService): PublicClientApplication {
  return configService.getMsalConfigurationsV2();
}

export function msalAngularConfigFactory(configService: ConfigurationService): MsalInterceptorConfiguration {
  const protectedResourceMap = configService.getResourceMapV2();
  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

@NgModule({
  imports: [MsalModule]
})
export class AuthenticationModule {
  constructor( @Optional() @SkipSelf() parentModule: AuthenticationModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }

  public static forRoot(config?: Configuration): ModuleWithProviders<AuthenticationModule> {

    return {
      ngModule: AuthenticationModule,
      providers: [
        ConfigurationService,
        { provide: AUTH_CONFIG_TOKEN, useValue: config },
        {
          provide: APP_INITIALIZER,
          useFactory: initializerFactory,
          deps: [ConfigurationService, AUTH_CONFIG_TOKEN],
          multi: true
        },
        { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },        
        { provide: MSAL_INSTANCE, useFactory: MsalInstanceFactory, deps: [ConfigurationService] },        
        { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: msalAngularConfigFactory, deps: [ConfigurationService] },
        MsalService,
        { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
        MsalGuard,
        MsalBroadcastService        
      ]
    };
  }
}


